import React from 'react'

import Checkbox from '../Fields/Checkbox'
import SingleInput from '../Fields/SingleInput'

import classes from './layout.css'

const ModuleTwelve = (props) => {
	return (
		<ol>
			<div className={classes.Section}>
				<h3>GENERAL RISKS</h3>
				<li id="1">
					<Checkbox
						controlFunc={props.addToForm}
						name={"cBox1"}
						value={props.consentForm.cBox1}
					/>
					Bleeding, swelling, infection, scarring, pain, numbness or altered sensation (possibly permanent) at the donor site which may require further treatment.
				</li>
				<li id="2">
					<Checkbox
						controlFunc={props.addToForm}
						name={"cBox2"}
						value={props.consentForm.cBox2}
					/>
					Allergic or other adverse reaction to the drugs used during or after the procedure.
				</li>
				<li id="3">
					<Checkbox
						controlFunc={props.addToForm}
						name={"cBox3"}
						value={props.consentForm.cBox3}
					/>
					The need for additional or more extensive procedures in order to obtain sufficient bone.
				</li>
				<li id="4">
					<Checkbox
						controlFunc={props.addToForm}
						name={"cBox4"}
						value={props.consentForm.cBox4}
					/>
					Rejection of bone particles from donor or recipient sites for some time after surgery.
				</li>
				<li id="5">
					<Checkbox
						controlFunc={props.addToForm}
						name={"cBox5"}
						value={props.consentForm.cBox5}
					/>
					Rejection of the bone graft.
				</li>
			</div>
			<div className={classes.Section}>
				<h3>RISKS AND COMPLICATIONS OF GRAFTING FROM WITHIN THE MOUTH AREA</h3>

				<li id="6">
					<Checkbox
						controlFunc={props.addToForm}
						name={"cBox6"}
						value={props.consentForm.cBox6}
					/>
					Damage to adjacent teeth which may require future root canal procedures, or may cause loss of those teeth.
				</li>
				<li id="7">
					<Checkbox
						controlFunc={props.addToForm}
						name={"cBox7"}
						value={props.consentForm.cBox7}
					/>
					Removal of adult teeth in order to obtain sufficient bone material.
				</li>
				<li id="8">
					<Checkbox
						controlFunc={props.addToForm}
						name={"cBox8"}
						value={props.consentForm.cBox8}
					/>
					Numbness or pain in the area of the donor or recipient site, or more extensive area, which may be temporary or permanent.
				</li>
				<li id="9">
					<Checkbox
						controlFunc={props.addToForm}
						name={"cBox9"}
						value={props.consentForm.cBox9}
					/>
					Penetration of the sinus or nasal cavity in the upper jaw, which could result in infection or other complication required additional drug or surgical treatment.
				</li>
			</div>
			<div className={classes.Section}>
				<h3>RISKS AND COMPLICATIONS OF BONE GRAFTING FROM THE HIP REGION</h3>

				<li id="10">
					<Checkbox
						controlFunc={props.addToForm}
						name={"cBox10"}
						value={props.consentForm.cBox10}
					/>
					Numbness, burning and/or pain of the hip, thigh or buttocks, temporary or permanent.
				</li>
				<li id="11">
					<Checkbox
						controlFunc={props.addToForm}
						name={"cBox11"}
						value={props.consentForm.cBox11}
					/>
					Gait disturbance - inability to walk normally which may be temporary or permanent.
				</li>
				<li id="12">
					<Checkbox
						controlFunc={props.addToForm}
						name={"cBox12"}
						value={props.consentForm.cBox12}
					/>
					Hematoma requiring further treatment and hospitalization.
				</li>
				<li id="13">
					<Checkbox
						controlFunc={props.addToForm}
						name={"cBox13"}
						value={props.consentForm.cBox13}
					/>
					Perforation into the abdominal cavity requiring further treatment and hospitalization.
				</li>
				<li id="14">
					<Checkbox
						controlFunc={props.addToForm}
						name={"cBox14"}
						value={props.consentForm.cBox14}
					/>
					Sciatica - radiating pain to the legs from irritation of the sciatic nerve which may persist.
				</li>
				<li id="15">
					<Checkbox
						controlFunc={props.addToForm}
						name={"cBox15"}
						value={props.consentForm.cBox15}
					/>
					Unsightly scarring at the incision site which may remain so despite efforts at later revision.
				</li>
			</div>
			<div className={classes.Section}>

			<h3>RISKS AND COMPLICATIONS OF BONE GRAFTING FROM THE LEG REGION</h3>
				<li id="16">
					<Checkbox
						controlFunc={props.addToForm}
						name={"cBox16"}
						value={props.consentForm.cBox16}
					/>
					Numbness, burning and/or pain of the leg or area where the graft is taken, temporary or permanent.
				</li>
				<li id="17">
					<Checkbox
						controlFunc={props.addToForm}
						name={"cBox17"}
						value={props.consentForm.cBox17}
					/>
					Gait disturbance - inability to walk normally - which may be temporary or permanent.
				</li>
				<li id="18">
					<Checkbox
						controlFunc={props.addToForm}
						name={"cBox18"}
						value={props.consentForm.cBox18}
					/>
					Hematoma (clot) requiring further treatment and hospitalization.
				</li>
				<li id="19">
					<Checkbox
						controlFunc={props.addToForm}
						name={"cBox19"}
						value={props.consentForm.cBox19}
					/>
					Unsightly scarring at the incision site which may remain so despite efforts later.
				</li>
			</div>
			<div className={classes.Section}>

				<h3>BANKED BONE (freeze-dried, lyophilized, demineralized, xenografts) OR BONE SUBSTITUTES</h3>
				<p>On occasion, additional donated, processed, or artificial bone substitutes are used to supplement the patient’s bone, or to spare an extensive graft harvesting procedure. If used, such materials may have separate risks including, but not limited to:</p>
				<li id="20">
					<Checkbox
						controlFunc={props.addToForm}
						name={"cBox20"}
						value={props.consentForm.cBox20}
					/>
					Rejection of the donated or artificial graft material.
				</li>
				<li id="21">
					<Checkbox
						controlFunc={props.addToForm}
						name={"cBox21"}
						value={props.consentForm.cBox21}
					/>
					The remote chance of viral or bacterial disease transmission from processed bone.
					I understand that in my grafting procedure, the use of
					
					<SingleInput
						name={"paragraph2"}
						controlFunc={props.addToForm}
						inputType={"text"}
						id={"field1"}
						placeholder={"autogenous, demineralized, etc."}
						value={props.consentForm.paragraph2.field1}
					/> bone is expected to be taken from
					<SingleInput
						name={"paragraph2"}
						controlFunc={props.addToForm}
						inputType={"text"}
						id={"field2"}
						placeholder={"note area"}
						value={props.consentForm.paragraph2.field2}
					/>plus
					<SingleInput
						name={"paragraph2"}
						controlFunc={props.addToForm}
						inputType={"text"}
						id={"field3"}
						placeholder={"other area"}
						value={props.consentForm.paragraph2.field3}
					/>.
				</li>
			</div>
		</ol>
	)
}

export default ModuleTwelve


// WEBPACK FOOTER //
// ./src/components/Modules/12.js